export default "__VITE_ASSET__BpClqxgZ__"